import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CSSTransition from 'react-transition-group/CSSTransition';

// Components
import Packages from './Packages';
import OptionalCoverages from '../OptionalCoverages';
import Basic from './Basic';

class ProductSelector extends Component {
  render() {
    const {
      productBoxes,
      variant,
      advancedCoverage,
    } = this.props;

    const screenWidth = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;

    const selectorClass = classNames(
      'product-selector__inner grid__col grid__col--12', {
        'grid__col--md-4': advancedCoverage,
        'grid__col--md-12': !advancedCoverage,
        'grid__col--md-4 grid__col--offset-4': !advancedCoverage &&
          productBoxes.length === 1 && screenWidth > 768,
      }
    );

    const productBoxClass = classNames(
      'product-selector--feature grid ', {
        'productbox__outer': variant !== 'basic',
      }
    );
    const that = this;

    if (!this.state.show) {
      setTimeout(() => { that.setState({ show: true }); }, 10);
    }

    return (
      <div>
        <CSSTransition
          in={this.state.show}
          timeout={1500}
          classNames="slideInBottom__bounce"
          unmountOnExit
        >
          <div className={productBoxClass}>
            {this.props.advancedCoverage &&
            <div className="grid__col grid__col--12 grid__col--md-8 advanced-coverage">
              <OptionalCoverages {...this.props} />
            </div>
            }
            <div className={selectorClass}>
              {variant === 'packages' &&
              <Packages {...this.props} />
              }
              {variant === 'basic' &&
              <Basic {...this.props} />
              }
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default ProductSelector;

ProductSelector.defaultProps = {
  actions: [],
  advancedCoverage: false,
  variant: 'packages',
  productBoxes: [],
};

ProductSelector.propTypes = {
  initialValues: PropTypes.object.isRequired,
  productBoxes: PropTypes.array,
  userData: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  advancedCoverage: PropTypes.bool,
  actions: PropTypes.array,
  variant: PropTypes.string,
  productFooterNote: PropTypes.string.isRequired,
  labelActions: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  coverageText: PropTypes.string.isRequired,
  recommendedText: PropTypes.string.isRequired,
  toolTip: PropTypes.string.isRequired,
  buttonTextMobile: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/ProductSelector/index.jsx